import { BookmarkDocument, HistoryElement } from '@client/types'
import { createAsyncAction } from '@utils/createAsyncAction'

export const fetchBookmarks = createAsyncAction<
  Record<string, HistoryElement>,
  Record<string, BookmarkDocument>,
  undefined
>('@BOOKMARKS/FETCH_BOOKMARKS')
